import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";
import createMutationsSharer from "vuex-shared-mutations";

import cart from './modules/cart';
import locale from './modules/locale';
import meta from './modules/meta';

export const store = new Vuex.Store({
	state: {
		mobileState: false
	},
	getters: {
		mobileState(state){
			return state.mobileState;
		}
	},
	mutations: {
		UpdateMobileState(state, data) {
			state.mobileState = data;
		},
	},
	actions: {
		UpdateMobileState({commit}, data) {
			commit('UpdateMobileState', data);
		},
	},
    plugins: [
		createPersistedState({paths: ['cart']}),
		createMutationsSharer({ predicate: ["cart/toogleItem", 'cart/set', 'cart/addTo', 'cart/deleteItemIndex', 'cart/deleteItemId'] })
	],
	modules: {
		cart,
		locale,
		meta
	},
	strict: process.env.NODE_ENV !== 'production'
});


// WEBPACK FOOTER //
// ./src/store/index.js